var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00096 15C5.89721 15 5.00189 14.1606 5.00189 13.125H9.00002C9.00002 14.1606 8.1047 15 7.00096 15ZM0.270017 10.614C0.873767 10.0058 2.00345 9.09082 2.00345 6.09375C2.00345 3.81738 3.70596 1.99512 6.00158 1.54805V0.9375C6.00158 0.419824 6.44908 0 7.00096 0C7.55283 0 8.00033 0.419824 8.00033 0.9375V1.54805C10.296 1.99512 11.9985 3.81738 11.9985 6.09375C11.9985 9.09082 13.1281 10.0058 13.7319 10.614C13.9194 10.8029 14.0025 11.0288 14.001 11.25C13.9975 11.7305 13.5953 12.1875 12.9978 12.1875H1.00408C0.40658 12.1875 0.00407982 11.7305 0.000954628 11.25C-0.000607491 11.0288 0.0825167 10.8026 0.270017 10.614Z",
    fill: "#155892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b684be8b24194e11278d8ec961c6f3d7.svg";
export { ForwardRef as ReactComponent };